import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CLASS_SLUG_PARAM } from './class.model';
import { ClassQuery } from './class.query';

export const archivedClassGuard: CanActivateFn = (route) => {
  const classQuery = inject(ClassQuery);
  const router = inject(Router);

  const classSlug = route.parent?.paramMap.get(CLASS_SLUG_PARAM);
  const classEntity = classQuery.getAllUIEntities().find((c) => c.slug === classSlug);

  if (classEntity?.archived_at) {
    return router.createUrlTree(['/classes', classSlug]);
  }

  return true;
};
